<template>
    <div class="left-section">
        <div class="logo-img" @click="$router.push({
			name: 'Login'
		})">
            <img src="/img/Dimitra Deforestation Compliance Logo White.png">
			<!-- <h4 class="white--text ml-1 text-h6 font-weight-black">DIMITRA</h4> -->
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped lang="scss">


.left-section {
	background-image: url('../../../public/img/deforestation.jpg');
	background-repeat: no-repeat;
  	background-size: cover;
	padding: 16px 20px;
	height: 100vh;
}
.left-section .logo-img {
	width: 140px;
	height: 55px;
	padding: 75px 75px;
	// padding-top: 75px;
	// border-radius: 200px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 50px;
	// background-color: $primary-color
}
.left-section .logo-img img{
	width: 200px;
	// border-radius: 50px;
}

</style>